export class ReceiptItem {

  barcode: string
  brand: string
  category: string
  name: string
  count: number
  pre_tax_price: number
  commission_rate: number
  tax_rate: number
  taxed: boolean
  shipped: boolean
  exchange_rate: number
  purchaser: string
  purchase_date: string
  shipping_fee: number

  constructor(data: any = {}) {
    this.barcode = data.barcode || null
    this.brand = data.brand || null
    this.category = data.category || null
    this.name = data.name || null
    this.count = data.count || 0
    this.pre_tax_price = data.pre_tax_price || 0
    this.tax_rate = data.tax_rate || 0
    this.commission_rate = data.commission_rate || 0
    this.taxed = data.taxed === undefined || data.taxed === null ? true : Boolean(data.taxed)
    this.shipped = Boolean(data.shipped)
    this.exchange_rate = data.exchange_rate || 1
    this.purchaser = data.purchaser || null
    this.purchase_date = data.purchase_date || ''
    this.shipping_fee = data.shipping_fee || 0
  }

  get cost(): number {
    return this.pre_tax_price * (1 + this.commission_rate + this.tax_rate)
  }

  get shipping(): string {
    return this.shipped ? '是' : '否'
  }

}



// WEBPACK FOOTER //
// ./src/app/models/text-receipt/receipt-item.ts